<template>
    <div class="dataselect-query">
        <a-form class="dataselect-query-form" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
            <a-row>
                <template v-for="(item, index) in queryFields">
                    <a-col :span="8" :key="index" v-if="!collapsed || index < 2">
                        <a-form-item :label="item.label">
                            <FGDictSelect
                                :dictNo="item.dictNo"
                                v-model="queryValues[index]"
                                mode="multiple"
                                show-arrow
                                :filter-option="
                                    (input, option) => {
                                        return option.componentOptions.children[0].text.indexOf(input) >= 0;
                                    }
                                "
                                v-if="item.dictNo"
                            />
                            <a-range-picker valueFormat="YYYY-MM-DD" v-model="queryValues[index]" v-else-if="item.type === 'DATE'" />
                            <template v-else-if="item.type === 'NUMBER'">
                                <div class="dataselect-query-numberrange">
                                    <a-input-number v-model="queryValues[index][0]" />
                                    <span>~</span>
                                    <a-input-number v-model="queryValues[index][1]" />
                                </div>
                            </template>
                            <a-input v-model="queryValues[index]" v-else />
                        </a-form-item>
                    </a-col>
                </template>
                <a-col :span="buttonSpan">
                    <div class="dataselect-query-buttons">
                        <a-button
                            type="link"
                            :icon="collapsed ? 'down' : 'up'"
                            @click="collapsed = !collapsed"
                            style="margin-right: 8px"
                            v-if="queryFields.length >= 3"
                        >
                            {{ collapsed ? "展开" : "收起" }}
                        </a-button>
                        <a-button type="primary" @click="handleQuery" style="margin-right: 8px">查询</a-button>
                        <a-button @click="handleReset">重置</a-button>
                    </div>
                </a-col>
            </a-row>
        </a-form>
    </div>
</template>
<script>
export default {
    name: "FGDataSelectQuery",
    props: {
        queryFields: {
            type: Array,
            default: () => []
        }
    },
    data() {
        let queryValues = this.initFieldValues();
        return {
            collapsed: true,
            queryValues
        };
    },
    computed: {
        buttonSpan() {
            if (this.queryFields.length < 3 || !this.collapsed) {
                return (3 - (this.queryFields.length % 3)) * 8;
            } else {
                return 8;
            }
        }
    },
    methods: {
        initFieldValues() {
            let result = [];
            this.queryFields.forEach((field, index) => {
                if (field.dictNo || field.type === "DATE" || field.type === "NUMBER") {
                    result[index] = [];
                } else {
                    result[index] = "";
                }
            });
            return result;
        },
        handleReset() {
            this.queryValues = this.initFieldValues();
        },
        handleQuery() {
            this.$emit(
                "query",
                this.queryFields.map((field, index) => {
                    return {
                        ...field,
                        value: this.queryValues[index]
                    };
                })
            );
        }
    }
};
</script>
<style lang="scss" scoped>
.dataselect-query {
    position: absolute;
    left: 0;
    top: 0;
    padding: 10px;
    z-index: 20;
    background-color: #fff;
    width: 100%;
    box-shadow: -1px 1px 4px rgba(0, 21, 41, 0.08);

    .dataselect-query-form {
        .dataselect-query-buttons {
            text-align: right;
            padding: 4px 0;
        }

        .dataselect-query-numberrange {
            display: flex;
            padding: 4px 0;

            > span {
                line-height: 32px;
            }

            ::v-deep .ant-input-number {
                flex: 1;
            }
        }

        ::v-deep .ant-form-item {
            display: flex;
            margin-bottom: 0px;
        }

        ::v-deep .ant-form-item-control-wrapper {
            flex: 1;
        }
    }
}
</style>
